import React from "react";

import { GridLegacy } from "@mui/material";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Extra() {
  const { menukaartVestigingId, vestigingId } = useFormContext();

  return (
    <Card style={{ maxWidth: 800 }}>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"hiddenOrders" + menukaartVestigingId}
            multiple={true}
            name={"hiddenOrders"}
            tDefault={
              "HIDDEN ORDERS (Deze Verborgen Orders worden automatisch toegevoegd bij ELK bestelde artikel uit deze categorie (menukaart))"
            }
            tKey={"menukaarten.form.extra.label.hiddenOrders"}
          />

          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"showArrangement" + menukaartVestigingId}
            multiple={true}
            name={"showArrangement"}
            tDefault={
              "ARRANGEMENT KAART (Deze kaart alleen weergeven als het gespecifigeerde arrangement is geselecteerd)"
            }
            tKey={"menukaarten.form.extra.label.showArrangement"}
          />

          <FormAsyncTC
            async={{
              url:
                "core/zones/search?fields=id as value, zoneName as label&per_page=50&sort_field=zoneName&vestiging_id=" +
                vestigingId,
              searchField: "zoneName",
            }}
            key={"zones" + vestigingId}
            multiple={true}
            name={"zones"}
            tKey={"Select a zone"}
          />

          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"menuDrinks" + menukaartVestigingId}
            multiple={true}
            name={"menuDrinks"}
            tDefault={"Menu drinken"}
            tKey={"menukaarten.form.menu.label.menuDrinken"}
          />
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"menuFood" + menukaartVestigingId}
            multiple={true}
            name={"menuFood"}
            tDefault={"Menu eten"}
            tKey={"menukaarten.form.menu.label.menuEten"}
          />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Extra;
